export default {
  transitions: {
    ease: '350ms cubic-bezier(0.215, 0.61, 0.355, 1)',
  },
}
